import { createAction, props } from '@ngrx/store';
import { UserAccountModel } from '@shared/data-access/models';

export const getDetail = createAction('[User Account] GET DETAIL', props<{ item: UserAccountModel }>());
